<template>
  <v-dialog :value="mostrarDialogoPropostasExcluidas" persistent :max-width="800">
    <v-card>
      <v-card-title class="primary modal-title" primary-title>
        Propostas Excluídas
      </v-card-title>
      <v-card-text class="pb-0 az-form-content">
        <div>
          <v-data-table :headers="colunas" :items="propostas.fornecedores"
                        no-data-text="Não há proposta excluída"
                        class="az-table-list" hide-actions>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.cnpj }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.emailPrincipal }}</td>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
      <v-card-actions class="acoes justify-center">
        <v-btn color="#777" flat @click="fecharModal">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalPropostasExcluidas',
  props: ['mostrarDialogoPropostasExcluidas', 'propostas'],
  data(){
    return {
      colunas: [
        {
          text: 'CPF/CNPJ',
          align: 'left',
          sortable: false,
          class: 'primary--text'
        },
        {
          text: 'Email',
          align: 'left',
          sortable: false,
          width: '100px',
          class: 'primary--text'
        },
        {
          text: 'Email Principal',
          align: 'left',
          sortable: false,
          width: '100px',
          class: 'primary--text'
        }
      ]
    }
  },
  methods: {
    fecharModal() {
      this.$emit('fechar')
    },
    async confirmarAcao() {
      this.$emit('confirmar')
    }
  }
}
</script>

<style lang="stylus" scoped>
.text-modal-confirm
  color #3A6861
  font-weight 600

.box-modal-confirm
  display flex
  flex-direction column
  justify-content center
  align-items center
  min-height 100px

.botao-primario
  padding 0 25px
  border 1px solid #7aa329
  background-color #7aa329 !important
  color #fff !important
  box-sizing border-box
  margin-left 15px !important

.acoes
  padding 20px 0 !important
</style>